import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Middle } from './Symbols/WidgetLayout';
import { TextLink } from './Symbols/WidgetLayoutCentrum';
import { sortBy } from './Utils/Sorters';
import Head2Head from './Components/Head2HeadWidget';
import { SmartTitle } from './Components/Head2HeadWidget/styles';
import { css } from 'emotion';
import { Wrapper as w1 } from './Components/WidgetSuggest/styles';
import { Link, Title } from './Components/WidgetMunicipalCount/styles';
import withDataLoader from './Utils/withDataLoader';

const wrapperCentrum = css`
	min-height: 0;
	max-height: 340px;
	${w1} {
		margin-top: 0;
	}
	${Title} + ${Link} {
		margin-bottom: 0;
	}
	${SmartTitle} {
		@media (min-width: 760px) {
			display: inline;
		}
	}
`;

class App extends React.PureComponent {

	state = {
		finalists: [],
		elected: [],
		meta: []
	}

	load() {
		this.props.loadDataAsync([`senate/${this.props.year}/vysledky_souhrn.json`])
			.then(([data]) => {
				const finalists = data.body.finalists.sort(sortBy(1, 'votes'));
				this.setState({
					finalists,
					elected: data.body.elected,
					meta: data.body.meta
				});
			}).catch(e => {
				console.error(e);
			});
	}

	componentDidMount() {
		this.load()
	}

	render() {
		return <Wrapper className={wrapperCentrum}>
			<Middle>
				{this.state.finalists.length > 0 && <Head2Head
					finalists={this.state.finalists.concat((this.state.elected))}
					faces={this.props.faces}
					roundIndex={1}
					meta={this.state.meta}
				>
					<div>
						<TextLink href={this.props.linkToSenate}>
							Přehled všech obvodů
						</TextLink>
					</div>
				</Head2Head>}
			</Middle>
		</Wrapper>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	linkToSenate: PropTypes.string.isRequired
};

App.defaultProps = {
	year: 2018,
	linkToSenate: '#'
};

export default withDataLoader(App)
